import api from "./api.js";

export default class FreePdfApplyApi {
  static async getList(data) {
    return await api.get(`api/free-pdf-apply`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/free-pdf-apply/${id}`);
  }
}
